import { Image } from '@/components/Image'
import { Link } from '@/components/Link'
import { Typography } from '@/components/Typography'
import { getLinkPathname } from '@/utils/urls'
import styles from './Author.module.scss'

export type WidgetAuthorInlineProps = {
  readonly url: string
  readonly image: {
    readonly filename: string
    readonly baseUrl: string
    readonly crop: string
    readonly heightRatio: 1
  }
  readonly fields: {
    readonly 'author-info': string
    readonly salutation: string
  }
}

export default function Author({
  item,
}: Readonly<{
  item: { model: WidgetAuthorInlineProps }
}>) {
  const model = item.model
  const image = model.image
  const { filename } = image ?? {}
  return (
    <Link href={getLinkPathname(model.url)} className={styles.author}>
      <Typography variant="m" weight="bold" color="darkgrey">
        {model.fields.salutation === 'male' ? 'Über den Autor' : 'Über die Autorin'}
      </Typography>
      <div className={styles.wrapper}>
        <Typography>{model.fields['author-info']}</Typography>
        {image && (
          <figure>
            <Image image={image} alt={filename} />
          </figure>
        )}
      </div>
    </Link>
  )
}
